<template>
  <div class="space-y-4">
    <div class="text-xl font-semibold">Annotations</div>
    <div class="mx-auto">
      <DButton severity="primary" class="w-full" size="small" @click="createNew"
        ><div class="flex items-center justify-center gap-2 text-base">
          <Plus size="14" />
          <div>Create New</div>
        </div></DButton
      >
    </div>

    <div class="mt-4">
      <BookmarkItem
        v-for="bookmark in filteredViewPoints"
        :key="bookmark.id"
        :item="bookmark"
        @contextmenu="showBookmarkContext($event, bookmark.code)"
        @click="handleClickBookmark(bookmark)" />

      <div v-if="filteredViewPoints.length === 0" class="flex items-center justify-center text-gray-700">
        No Bookmarks
      </div>
    </div>
  </div>

  <DContextMenu2 ref="bookmarkMenuRef" :model="bookmarkItems" />
</template>
<script setup>
import { BookmarkItem } from '@/components';
import { DContextMenu2, useConfirm } from '@disguise/cloud-ui';
import { computed, ref } from 'vue';

import { useNodeManager } from '@/composables/useNodeManager';
import { useCruxModuleStore } from '@/stores/api/cruxmodules';
import { cameraControls } from '@/threejs/core';

import { useComments } from '@/composables/useComments';
import { DButton, useToast } from '@disguise/cloud-ui';
import { Plus } from 'lucide-vue-next';

const { openNewCommentDialog, openEditCommentDialog } = useComments();

const cruxModuleStore = useCruxModuleStore();
const currentBookmarkId = ref(null);
const bookmarkMenuRef = ref(null);

const { confirmDialog } = useConfirm();
const { removeNode } = useNodeManager();
const toast = useToast();

const filteredViewPoints = computed(() => {
  return cruxModuleStore.cruxModules.filter((module) => module.type === 'annotation') || [];
});

const handleClickBookmark = (bookmark) => {
  updatedBookmark({ data: bookmark });
};

const updatedBookmark = (data) => {
  let bookmark = data.data;

  cameraControls.setTarget(bookmark.data.target.x, bookmark.data.target.y, bookmark.data.target.z, true);
  cameraControls.setPosition(bookmark.data.position.x, bookmark.data.position.y, bookmark.data.position.z, true);
};

const bookmarkItems = ref([
  {
    label: 'Edit',
    icon: 'pi pi-pencil',
    command: () => {
      openEditCommentDialog(currentBookmarkId.value);
    },
  },
  {
    label: 'Delete',
    icon: 'pi pi-trash',
    command: () => {
      confirmDialog('Confirmation', 'Are you sure you want to delete this bookmark?', 'Delete', 'Cancel').then(
        async (response) => {
          if (response) {
            try {
              const deleteResult = await removeNode(currentBookmarkId.value);
              if (!deleteResult)
                toast.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Failed to delete bookmark',
                  group: 'br',
                  life: 5000,
                });
            } catch (error) {
              console.error('Error deleting bookmark:', error);
              toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to delete bookmark',
                group: 'br',
                life: 5000,
              });
            }
          }
        }
      );
    },
  },
]);

const showBookmarkContext = ($event, bookmarkId) => {
  currentBookmarkId.value = bookmarkId;
  bookmarkMenuRef.value.show($event);
};

const createNew = () => {
  openNewCommentDialog();
};
</script>
